import { Button, Card, CardContent, Stack } from "@mui/joy";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "../../i18n";
import AddIcon from "@mui/icons-material/Add";
import GroupOutlinedIcon from "@mui/icons-material/GroupOutlined";

export default function TeamActionCard() {
  const navigate = useNavigate();
  const t = useTranslation();

  return (
    <Card
      variant="soft"
      orientation="horizontal"
      sx={{
        background: "hsl(0deg 0% 31.06% / 35%)",
      }}
    >
      <CardContent>
        <Stack direction="column" gap={2}>
          <Button
            startDecorator={<GroupOutlinedIcon />}
            variant="outlined"
            onClick={() => navigate("./join")}
          >
            {t("Join Brand or Agency")}
          </Button>
          <Button
            startDecorator={<AddIcon />}
            variant="outlined"
            onClick={() => navigate("./create-brand")}
          >
            {t("Register Brand")}
          </Button>
          <Button
            startDecorator={<AddIcon />}
            variant="outlined"
            onClick={() => navigate("./create-agency")}
          >
            {t("Register Agency")}
          </Button>
        </Stack>
      </CardContent>
    </Card>
  );
}
